import {
  Box,
  Checkbox,
  FormControl,
  FormControlLabel,
  InputLabel,
  MenuItem,
  Select,
  TextField,
} from "@mui/material";
import { Create } from "@refinedev/mui";
import { useForm } from "@refinedev/react-hook-form";
import { Controller } from "react-hook-form";
import { challengeTypeOptions, type ChallengeTypeOption } from "@/interfaces";

type ChallengeFormValues = {
  name: string;
  type: ChallengeTypeOption;
  actionKey: string;
  targetCount: number;
  creditReward: number;
  isActive: boolean;
};

export const ChallengeCreate = () => {
  const {
    saveButtonProps,
    refineCore: { formLoading },
    control,
    register,
    formState: { errors },
  } = useForm<ChallengeFormValues>({
    defaultValues: {
      name: "",
      type: challengeTypeOptions[0],
      actionKey: "",
      targetCount: 0,
      creditReward: 0,
      isActive: true,
    },
  });

  return (
    <Create isLoading={formLoading} saveButtonProps={saveButtonProps}>
      <Box
        component="form"
        sx={{ display: "flex", flexDirection: "column" }}
        autoComplete="off"
      >
        <TextField
          {...register("name", {
            required: "Name is required",
          })}
          error={!!errors?.name}
          helperText={errors?.name?.message?.toString()}
          margin="normal"
          fullWidth
          InputLabelProps={{ shrink: true }}
          type="text"
          label="Name"
          name="name"
        />

        <Controller
          control={control}
          name="type"
          rules={{
            required: "Type is required",
          }}
          render={({ field }) => (
            <FormControl margin="normal" fullWidth error={!!errors?.type}>
              <InputLabel id="challenge-type-label">Type</InputLabel>
              <Select
                {...field}
                labelId="challenge-type-label"
                label="Type"
              >
                {challengeTypeOptions.map((option) => (
                  <MenuItem key={option} value={option}>
                    {option}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          )}
        />

        <TextField
          {...register("actionKey", {
            required: "Action key is required",
          })}
          error={!!errors?.actionKey}
          helperText={errors?.actionKey?.message?.toString()}
          margin="normal"
          fullWidth
          InputLabelProps={{ shrink: true }}
          type="text"
          label="Action Key"
          name="actionKey"
        />

        <TextField
          {...register("targetCount", {
            required: "Target count is required",
            valueAsNumber: true,
          })}
          error={!!errors?.targetCount}
          helperText={errors?.targetCount?.message?.toString()}
          margin="normal"
          fullWidth
          InputLabelProps={{ shrink: true }}
          type="number"
          label="Target Count"
          name="targetCount"
        />

        <TextField
          {...register("creditReward", {
            required: "Credit reward is required",
            valueAsNumber: true,
          })}
          error={!!errors?.creditReward}
          helperText={errors?.creditReward?.message?.toString()}
          margin="normal"
          fullWidth
          InputLabelProps={{ shrink: true }}
          type="number"
          label="Credit Reward"
          name="creditReward"
        />

        <Controller
          control={control}
          name="isActive"
          render={({ field }) => (
            <FormControlLabel
              sx={{ mt: 1 }}
              control={
                <Checkbox
                  checked={!!field.value}
                  onChange={(_, checked) => field.onChange(checked)}
                />
              }
              label="Active"
            />
          )}
        />
      </Box>
    </Create>
  );
};

